import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Arrow from '../icons/Arrow'
import { SET_SELECTED_DAY } from '../redux/timeSlotsReducer'
import { RootReducer } from '../redux/rootReducer'
const getDaysInMonth = (year: number, month: number) => {
  return new Date(year, month + 1, 0).getDate()
}

const getStartingDayOfMonth = (year: number, month: number) => {
  const date = new Date(year, month, 1)
  return date.getDay()
}

const getMonthName = (monthNumber: number): string => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  return months[monthNumber] || 'Invalid month number'
}

const Calendar = () => {
  const selectedDay = useSelector((state: RootReducer) => state.timeSlotsReducer.selectedDay)
  const dispatch = useDispatch()
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth())
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear())

  const decreaseMonth = () => {
    if (currentMonth <= 0) {
      setCurrentMonth(11)
      setCurrentYear((prev) => prev - 1)
    } else {
      setCurrentMonth((prev) => prev - 1)
    }
  }

  const increaseMonth = () => {
    if (currentMonth >= 11) {
      setCurrentMonth(0)
      setCurrentYear((prev) => prev + 1)
    } else {
      setCurrentMonth((prev) => prev + 1)
    }
  }

  const prepareDaysArray = (currentMonth: number, currentYear: number): string[] => {
    const daysInMonth = getDaysInMonth(currentYear, currentMonth)
    const startingDay = getStartingDayOfMonth(currentYear, currentMonth)
    const daysArray = Array.from({ length: daysInMonth }, (x, i) => `${i + 1}`)
    const emptyDays = Array.from({ length: startingDay }, (x, i) => '')
    return [...emptyDays, ...daysArray]
  }

  const isTutorAvailableAtDay = (dayNumber: string, currentMonth: number, currentYear: number) => {
    return true
  }

  const onDayClick = (day: string) => {
    if (isTutorAvailableAtDay(day, currentMonth, currentYear)) {
      dispatch(SET_SELECTED_DAY({ day, year: currentYear, month: currentMonth }))
    }
  }

  const functionClasses = (dayNumber: string, currentMonth: number, currentYear: number) => {
    if (isNaN(parseInt(dayNumber))) {
      return ''
    }

    if (dayNumber === selectedDay.day && currentMonth === selectedDay.month && currentYear === selectedDay.year) {
      return '!text-[white] bg-darkRed rounded-full cursor-pointer]'
    }

    if (isTutorAvailableAtDay(dayNumber, currentMonth, currentYear)) {
      return '!text-[white] bg-coolGray rounded-full cursor-pointer'
    }
  }

  return (
    <div className="flex">
      <div className="max-w-[20rem]">
        <div className="flex justify-between items-center px-3">
          <div className="text-18">
            {getMonthName(currentMonth)} {currentYear}
          </div>
          <div className="flex">
            <Arrow onClick={decreaseMonth} style={{ width: '20px', transform: 'rotate(180deg)', cursor: 'pointer' }} />
            <div className="w-[0.5rem]" />
            <Arrow onClick={increaseMonth} style={{ width: '20px', cursor: 'pointer' }} />
          </div>
        </div>
        <div id="days-labels" className="flex">
          {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((label) => (
            <div className="w-[2.55rem] text-center py-3 border-white border " key={label}>
              {label}
            </div>
          ))}
        </div>
        <div id="calendar-days" className="flex flex-wrap">
          {prepareDaysArray(currentMonth, currentYear).map((item, idx) => (
            <div
              onClick={() => onDayClick(item)}
              className={`w-[2.55rem] font-domine border-white border text-center py-2 text-lightGray ${functionClasses(
                item,
                currentMonth,
                currentYear
              )}`}
              key={idx}>
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Calendar
